import ResourceItem from "./ResourceItem";
export default ResourceItem;
